const traders = {
  steps: {
    select: 'Seleziona i parametri prezzo',
    validate: 'Valida e scarica il listino',
  },
  index: 'Componi prezzi Stock offers',
  select_type_filter: 'Filtra per',
  discount: 'Maggiorazione',
  id: 'ID',
  threshold: 'Soglia giacenza',
  threshold_hint: 'Filtra per giacenza maggiore',
  cost: 'Seleziona il costo da utilizzare',
  base_cost: 'Costo selezionato',
  final_cost: 'Prezzo finale',
  increase: 'Maggiorazione',
  manufacturer_name: 'Produttore',
  manufacturer_id: 'Codice produttore',
  last_sell_date_hint: 'Filtra per data ultima vendita inferiore',
  availability: 'Disponibilità',
  download: 'Scarica Listino',
}

export default traders
